import * as React from "react";
const SvgTwinningWisp = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 128 128", contentScriptType: "text/ecmascript", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M13.2 113.2C12 34 115 87 114.2 14.2", style: {
  stroke: "red",
  fill: "none",
  strokeWidth: 3
}, transform: "translate(.35 .546)" }), /* @__PURE__ */ React.createElement("path", { d: "m96 31 9 30", style: {
  stroke: "#f03",
  strokeWidth: 3
}, transform: "translate(-74 33)" }), /* @__PURE__ */ React.createElement("path", { d: "m96 31 9 30", style: {
  stroke: "#f03",
  strokeWidth: 3
}, transform: "translate(-1)" }));
export default SvgTwinningWisp;
